const WINDOW_THRESHOLD = 960;

export default WINDOW_THRESHOLD
